import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import QualityMeasurementRegModal from "../../../../modal/PC/quality/QualityMeasurementRegModal";
import QualityMeasurementUpdateModal from "../../../../modal/PC/quality/QualityMeasurementUpdateModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from 'react-router-dom';

const QualityMeasurement = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [keyword, setKeyword] = useState({
        search:''
    });
    const [isRegModalOpen, setRegModalOpen] = useState(false);
    const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectQualityMeasurementID, setSelectQualityMeasurementID] = useState('');
    const [paramID, setParamID] = useState('');
    const [initialEditOpenDone, setInitialEditOpenDone] = useState(true);
    
    // Grid정의
    const handleSetting = () => {
        setColumns([
            (MenuUpdateExistYN === "Y"?
            {
                field: 'updated',
                headerName: '수정',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<EditIcon color="primary" />} onClick={() => {UpdateClick(params)}} label="Edit" />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            (MenuDeleteExistYN === "Y"?
            {
                field: 'deleted',
                headerName: '삭제',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<DeleteIcon color={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y'? "error" : "grey"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y'? false : true } />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            { field: 'id', headerName: 'quality_measurement_id', width: 0, headerAlign: 'center' },
            { field: 'quality_measurement_id', headerName: 'quality_measurement_id', width: 0, headerAlign: 'center'},
            { field: 'quality_measurement_number', headerName: '품질측정번호', width: 150, headerAlign: 'center', align:'center'},
            { field: 'quality_measurement_lotno', headerName: '품질LotNo', width: 180, headerAlign: 'center', align:'center'},
            { field: 'quality_id', headerName: 'quality_id', width: 0, headerAlign: 'center', align:'center'},
            { field: 'quality_name', headerName: '품질명', width: 250, headerAlign: 'center', align:'left'},
            { field: 'quality_item_name', headerName: '품목', width: 150, headerAlign: 'center', align:'left'},
            { field: 'quality_item_spec', headerName: '규격', width: 300, headerAlign: 'center', align:'left'},
            { field: 'quality_measurement', headerName: '측정값(옵션)', width: 120, headerAlign: 'center', align:'left' },
            { field: 'quality_measurement_result_name', headerName: '측정결과', width: 100, headerAlign: 'center', align:'center' },
            { field: 'quality_measurement_user_name', headerName: '측정자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'quality_measurement_datetime', headerName: '측정일시', width: 180, headerAlign: 'center', align:'center' },
            
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        quality_measurement_id: false,
        quality_measurement_number: true,
        quality_measurement_lotno: true,
        quality_id: false,
        quality_name: true,
        quality_item_name: true,
        quality_item_spec: true,
        deleted: true,
        updated: true,
        quality_measurement: true,
        quality_measurement_result_name: true,
        quality_measurement_user_name: true,
        quality_measurement_datetime: false
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            
            if(params.quality_measurement_id !== null && typeof params.quality_measurement_id !== 'undefined'){
                setParamID(params.quality_measurement_id);
            }
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView();
        }
    }, [keyword.status])

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInit();
            handleView();
        }
    }, [MenuID]);
    
    useEffect(() => {
        if (originRows.length > 0 && paramID && initialEditOpenDone) {
            const filtered = originRows.filter(row => String(row.quality_measurement_id) === String(paramID));

            if (filtered.length > 0) {
                setSelectQualityMeasurementID(paramID);
                setUpdateModalOpen(true);
                setModalTitle('품질 측정 수정');
                setInitialEditOpenDone(false);
            }
        }
    }, [originRows, paramID]);
    
    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/QualityMeasurement/List',
            {
            params : {
                search : keyword.search
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            const PermissionMap = {};
            response.data.forEach(row => {
                if (!PermissionMap[row.quality_measurement_id]) {
                    PermissionMap[row.quality_measurement_id] = [row.reg_user_id, row.update_user_id, row.quality_measurement_user_id].includes(Number(localStorage.getItem('user_id')));
                }
            });

            var array = response.data.map((item, index) => ({
                id: item.quality_measurement_id,
                quality_measurement_id: item.quality_measurement_id,
                quality_measurement_number: item.quality_measurement_number,
                quality_measurement_lotno: item.quality_measurement_lotno,
                quality_id: item.quality_id,
                quality_name: item.quality_name,
                quality_item_name: item.quality_item_name,
                quality_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.quality_item_spec, item.quality_item_width, item.quality_item_depth, item.quality_item_height),
                quality_measurement: (typeof item.quality_measurement_value === 'undefined')? item.quality_measurement_option_name:item.quality_measurement_value,
                quality_measurement_result_name: item.quality_measurement_result_name,
                quality_measurement_user_name: item.quality_measurement_user_name,
                quality_measurement_datetime: Moment(item.quality_measurement_datetime).format('YYYY-MM-DD HH:mm:ss'),
                update_flag: PermissionMap[item.quality_measurement_id] ? 'Y' : 'N'
            }));
            setOriginRows(response.data);
            setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false); 
        });

    }

    const handleInit = () => {
        setKeyword({
            search: ''
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            id: false,
            quality_measurement_id: false,
            quality_measurement_number: true,
            quality_measurement_lotno: true,
            quality_id: false,
            quality_name: true,
            quality_item_name: true,
            quality_item_spec: true,
            deleted: true,
            updated: true,
            quality_measurement: true,
            quality_measurement_result_name: true,
            quality_measurement_user_name: true,
            quality_measurement_datetime: false
        });
    };

    const handleReg = () => {
        setRegModalOpen(true);
        setModalTitle('품질 측정 등록');
    };
    
    const UpdateClick = (object) => {
        setUpdateModalOpen(true);
        setModalTitle('품질 측정 수정');
        setSelectQualityMeasurementID(object.row.id);
    };

    const DeleteClick = (object) => {
        Swal.fire({
            title: '품질측정번호 '+object.row.quality_measurement_number+' 삭제',
            html : '품질측정번호 '+object.row.quality_measurement_number+'을(를) <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton : true,
            confirmButtonColor : "#d33",
            confirmButtonText : "삭제",
            cancelButtonText : "닫기"
        }).then((result) => {
            if (result.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);

                axios.post('/api/p/QualityMeasurement/Delete', new URLSearchParams({
                    delete_quality_measurement_id: object.row.id,
                    folder: 'QualityMeasurement'
                }),
                { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){
                        Swal.fire({
                            title: '품질측정번호 '+object.row.quality_measurement_number+' 삭제 완료',
                            text: '정상적으로 품질측정번호 '+object.row.quality_measurement_number+'가 삭제 되었습니다.',
                            confirmButtonText: '확인',
                            timer: 5000,
                            timerProgressBar: true
                        }).then((result) => {
                            setRows((rows) => rows.filter((data) => data.id !== object.row.id));
                        });
                    }else{
                        appStore.capture();
                    }
                })
                .catch(function (error) {
                    appStore.capture();
                })
                .finally(() => {
                    appStore.setLoading(false); 
                })
            }
        });
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSubmitSearch = (e) => {
        //입력 검색어는 Enter로 조회.
        if (e.key === "Enter") {
          handleView();
        }
    };
    
    const handleRegSuccessSave = (regID) => {
        setModalTitle('품질 측정 수정');
        setRegModalOpen(false);
        handleView();
        Swal.fire({
            title: '품질 측정 등록 완료',
            text: '정상적으로 품질측정이 등록 되었습니다.',
            confirmButtonText: '확인',
            timer: 5000,
            timerProgressBar: true
        }).then((result) => {
            // 수정 화면 불러오기
            setUpdateModalOpen(true);
            setSelectQualityMeasurementID(Number(regID));
        });
    };

    const handleExcel = () => {
        var filename = '품질측정'
        axios.get('/api/p/QualityMeasurement/Excel',
        {   
            params : { search : keyword.search, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    { MenuUpdateYN === "Y"?
                    <Button 
                        onClick={ handleReg }
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                    </Button> : <></> }
                    {isRegModalOpen  && MenuUpdateYN === 'Y'&& (
                        <QualityMeasurementRegModal
                        onClose={() => {
                            setRegModalOpen(false);
                        }}
                        title={modalTitle}
                        handleRegSuccessSave={handleRegSuccessSave}
                        MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '300px' } }>
                            <input type="text" placeholder="검색" value={keyword.search} name="search" onChange={(e) => onChange(e) } onKeyPress={onSubmitSearch} autoComplete="off" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="grid_sub" style={ { width: '100%', fontSize: '17px' } }>
                    <DataGrid
                        className="grid_main"
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                    />
                    {isUpdateModalOpen && (
                        <QualityMeasurementUpdateModal
                            onClose={() => {
                                setUpdateModalOpen(false);
                            }}
                            title={modalTitle}
                            id={selectQualityMeasurementID}
                            originRows={originRows.filter(row => String(row.quality_measurement_id) === String(selectQualityMeasurementID))}
                            handleView={handleView}
                            MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default QualityMeasurement;
